<template>
  <v-dialog v-model="showDelete" width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        Delete Hotspot
      </v-card-title>

      <v-card-text>
        <div class="warningText">
          Are you sure you would like to delete this Hotspot?
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="failed" style="color: red;">Failed</div>
        <div v-if="processing">Processing</div>
        <v-btn v-if="!processing" color="primary" text @click="reset()">
          cancel
        </v-btn>
        <v-btn v-if="canSubmit" color="primary" text @click="submitMove()">
          delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { hasGroupByName } from "@/services/user/user.service";
import { deleteHotspot } from "@/services/grids/hotspots.service";

export default {
  name: "HotspotDelete",
  props: {
    features: {
      type: Array,
    },
  },
  data: function () {
    return {
      showDelete: false,
      processing: false,
      finished: false,
      failed: false,
      geohash: null,
    };
  },
  computed: {
    canSubmit: function () {
      if (this.geohash && !this.finished && !this.processing) {
        return true;
      }
      return false;
    },
  },
  methods: {
    openModal: async function (geohash) {
      if (!hasGroupByName("MoveClusters_Access")) {
        return;
      }
      this.geohash = geohash;
      this.showDelete = true;
    },
    submitMove: async function () {
      this.processing = true;

      try {
        await deleteHotspot(this.geohash);
        this.finished = true;
        this.processing = false;
        this.reset();
      } catch (error) {
        console.error(error);
        this.failed = true;
        this.processing = false;
        this.finished = true;
      }
    },
    reset: function () {
      this.finished = false;
      this.processing = false;
      this.showDelete = false;
      this.clusterId = null;
      this.failed = false;
    },
  },
};
</script>

<style scoped>
.warningText {
  margin-top: 15px;
}
</style>
